export const TWO_FACTOR_RETURN_COMPLETION_DAYS_AMOUNT_MIN_VALUE = 1;
export const TWO_FACTOR_RETURN_COMPLETION_DAYS_AMOUNT_MAX_VALUE = 50;
